import { chapterOfLevel } from "./chapters.ts";
import { SORTING_CONTENT_VERSION, SORTING_PACK_LOADERS } from "./packs.generated.ts";
import { sortingPackSchema, type SortingLevel, type SortingPack } from "./schema.ts";

const packCache = new Map<number, Promise<SortingPack>>();

/** Loads (once) and validates the chapter pack that contains `levelId`. */
export function loadSortingChapter(chapter: number): Promise<SortingPack> {
  let pending = packCache.get(chapter);
  if (!pending) {
    const loader = SORTING_PACK_LOADERS[chapter];
    if (!loader) return Promise.reject(new Error(`no pack for chapter ${chapter}`));
    pending = loader().then((raw) => {
      const pack = sortingPackSchema.parse(raw);
      if (pack.contentVersion !== SORTING_CONTENT_VERSION) {
        throw new Error(`pack ${chapter} has version ${pack.contentVersion}`);
      }
      return pack;
    });
    pending.catch(() => packCache.delete(chapter));
    packCache.set(chapter, pending);
  }
  return pending;
}

export async function loadSortingLevel(levelId: number): Promise<SortingLevel> {
  const pack = await loadSortingChapter(chapterOfLevel(levelId).chapter);
  const level = pack.levels.find((candidate) => candidate.id === levelId);
  if (!level) throw new Error(`level ${levelId} missing from pack`);
  return level;
}
